import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

/**
 * Firebase Web SDK bootstrap for the primary login flow (Google OAuth via
 * Firebase Auth — see `client/src/shared/context/AuthContext.jsx`), ported
 * from the AngularJS `AuthService.loginWithGoogle()`/
 * `initializeFirebaseAuth()` (commit a6c16fa, "feat(login): troca login
 * para firebase").
 *
 * Config (apiKey, authDomain, projectId, allowedDomain) is fetched from the
 * backend at login time (`GET /users/firebase-config`,
 * `server_app/routes/userRouter.js`) rather than baked into `VITE_*` env
 * vars at build time — same as the legacy implementation. These values are
 * not secrets by Firebase's own design (they're always embedded in the
 * client bundle for any Firebase web app; access is controlled by Firebase
 * Auth/security rules, not by hiding them), but they are environment
 * -specific (LOCAL/HOMOLOG/PROD each has its own Firebase
 * project), so serving them from the backend keeps a single
 * per-environment source of truth instead of duplicating them into every
 * client env file.
 */

/**
 * Guards against re-initializing the Firebase app on repeated calls (e.g.
 * clicking "Entrar com Google" more than once, or Vite HMR re-executing
 * this module).
 */
function getOrInitFirebaseApp(config) {
  return getApps().length ? getApp() : initializeApp(config)
}

export function getFirebaseAuthFor(config) {
  return getAuth(getOrInitFirebaseApp(config))
}

/**
 * Builds a fresh `GoogleAuthProvider`, restricting the account chooser to
 * `allowedDomain` via the `hd` custom parameter — a UX-level hint mirroring
 * `AuthService`'s `provider.setCustomParameters({ hd: ... })`. This is not
 * the real security boundary (a user could still pick another account in
 * the chooser); the backend re-validates the domain on every
 * `POST /users/firebase-login` call regardless.
 */
export function createGoogleAuthProvider(allowedDomain) {
  const provider = new GoogleAuthProvider()
  if (allowedDomain) {
    provider.setCustomParameters({ hd: allowedDomain })
  }
  return provider
}
